import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  Renderer2,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "onsip-small-web-preview-frame",
  templateUrl: "./small-web-preview-frame.component.html",
  styleUrls: ["./small-web-preview-frame.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SmallWebPreviewFrameComponent {
  @ViewChild("saysoPreviewContainer", { read: ElementRef }) saysoPreviewContainer!: ElementRef;
  @Input() buttonColor!: string;
  @Input() buttonLocation: "right" | "left" = "right";
  @Input() gradientOverlay = false;
  @Input() width!: number;
  @Input() removedOnsipBranding = false;
  openWebPreview = true;

  constructor(private renderer: Renderer2) {}

  handleWebClick() {
    const saysoPreview = this.saysoPreviewContainer.nativeElement.querySelector(".sayso-preview");
    if (
      saysoPreview.classList.contains("exited") &&
      !saysoPreview.classList.contains("sayso-preview-transition")
    ) {
      this.renderer.addClass(saysoPreview, "sayso-preview-transition");
    }
    this.openWebPreview = !this.openWebPreview;
  }
}
